<app-dialog>
    <div class="kk-rte" appInterceptLinks [innerHTML]="data | safe: 'html'"></div>
</app-dialog>
